const CartBulkEditing = ({
  isBulkEditing,
  bulkEditValues,
  handleInputChange,
  handleBulkUpdate,
  setIsEditing,
  selectedItems,
  customerCartDataLength,
  handleSelectAll,
}) => {
  return (
    <>
      <div className="cart_left_top">
        <h3 className="cart-page-title">Cart</h3>
        {isBulkEditing ? (
          <div className="bult_variant_edit">
            <select
              name="carat"
              id="bult_variant_edit_carat"
              value={bulkEditValues.carat}
              onChange={handleInputChange}
            >
              <option value="10K">10KT</option>
              <option value="14K">14KT</option>
              <option value="18K">18KT</option>
            </select>
            <select
              name="clarity"
              id="bult_variant_edit_clarity"
              value={bulkEditValues.clarity}
              onChange={handleInputChange}
            >
              <option value="YW">Yellow Gold</option>
              <option value="W">White Gold</option>
              <option value="PW">Pink</option>
            </select>
            <button className="button" onClick={handleBulkUpdate}>
              Update
            </button>
          </div>
        ) : (
          ""
        )}
        <button
          className="button"
          onClick={() => setIsEditing((prev) => !prev)}
        >
          {isBulkEditing ? "close" : "Bulk Edit"}
        </button>
      </div>
      <div
        className="bulk_edit_all_con"
        style={{
          height: isBulkEditing ? "17px" : "0",
          opacity: isBulkEditing ? "1" : "0",
        }}
      >
        <input
          type="checkbox"
          name="bulk_edit_all_checkbox"
          className="bulk_edit_all_checkbox"
          checked={selectedItems.length === customerCartDataLength && customerCartDataLength > 0}
          onChange={(e) => handleSelectAll(e.target.checked)}
        />
        <span>Select all</span>
      </div>
    </>
  );
};

export default CartBulkEditing;
